import {
    Billing
} from './billing';

export const SET = 'one-state-billing-details/set';
export const RESET = 'one-state-billing-details/reset';
export const SELECT = 'one-state-billing-details/select';
export const SETPAYMENT = 'one-state-billing-details/setbillpayment';
export const SETPAYMENTSUCCESS = 'one-state-billing-details/setbillpaymentsuccess';

export interface State<V> {
    values?: V[];
    selected?: V;
    billpayment?: boolean;
    billpaymentsuccess?: boolean;
}

export type BillingState = State<Billing>;